<div *ngFor="let status of statuses">
	<div
		class="sdp-gateway-status"
		matTooltip="{{status.tooltip | translate}}"
		[hidden]="!visible"
	>
		<sdp-icon [icon]="status.icon"></sdp-icon>
		<span> {{ status.text | translate }} </span>
	</div>
</div>